import type { LayoutState } from './layoutStore';
import type { ChatTabsState } from './chatTabsStore';
import type { ProjectSyncState } from './projectStore';
import type {
  StoreFullSyncPayload,
  StoreSyncPayload,
} from '../electron/detached-window-types';

import type { TerraUIMessage } from '@terra/shared-dto-chat-types';

export const LAYOUT_SYNC_KEYS = [
  'mainContentTabs',
  'activeMainContentTabId',
  'tabHistory',
  'tabNavigationByTabId',
  'globalNavigation',
  'detachedTabIds',
  'isCopilotDetached',
  'selectedSidebarTab',
  'tabGroups',
  'endpointTabs',
  'webPageTabs',
  'tabSections',
] as const satisfies readonly (keyof LayoutState)[];

export const CHAT_TABS_SYNC_KEYS = [
  'chatTabs',
  'activeChatTabId',
] as const satisfies readonly (keyof ChatTabsState)[];

export const PROJECT_SYNC_KEYS = [
  'companyId',
  'targetId',
  'targetType',
  'selectedCompany',
  'selectedTarget',
] as const satisfies readonly (keyof ProjectSyncState)[];

export type LayoutSyncSlice = Pick<
  LayoutState,
  (typeof LAYOUT_SYNC_KEYS)[number]
>;

export type ChatTabsSyncSlice = Pick<
  ChatTabsState,
  (typeof CHAT_TABS_SYNC_KEYS)[number]
>;

export type ProjectSyncSlice = Pick<
  ProjectSyncState,
  (typeof PROJECT_SYNC_KEYS)[number]
>;

export type ChatInstancesSyncSlice = {
  queuedMessages: Array<[string, QueuedMessageSyncEntry[]]>;
};

export type QueuedMessageSyncEntry = {
  id: string;
  message: TerraUIMessage;
  createdAt: number;
  state: 'queued' | 'sending' | 'editing';
};

export type { StoreFullSyncPayload, StoreSyncPayload };
